import React from 'react'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import useStyles from './Style'

import DataItem from './DataItem'

const DadosEndereco = ({ endereco }) => {
    const classes = useStyles();
    return (
        <div className={classes.section}>
            <Typography className={classes.title}>Dados de Endereço</Typography>
            <Grid container spacing={2}>
                <DataItem label="CEP" value={endereco.cep} sm={2} />
                <DataItem label="Endereço" value={endereco.endereco} sm={6} />
                <DataItem label="Número" value={endereco.numero} sm={1} />
                <DataItem label="Complemento" value={endereco.complemento} sm={3} />
                
                <DataItem label="Bairro" value={endereco.bairro} sm={5} />
                <DataItem label="Município/UF" value={`${endereco.municipio} - ${endereco.uf}`} sm={7} />
            </Grid>
        </div>
    )
}

export default DadosEndereco;